import {hotelsThankYouApi} from '@ibibo/hotels-thankyou-api';

import {updateThankYouData, setThankYouLoading} from './hotels-thankyou-actions';

export const fetchThankYouData = ({
  id,
  successCallback,
  errCallback
}) => {
  return (dispatch) => {
    dispatch(setThankYouLoading(true));

    hotelsThankYouApi({
      paymentid: id
    }).then(response => {
      if (response && response.success) {
        successCallback && successCallback(response.data);
        dispatch(updateThankYouData({...response.data}, false));
      } else {
        errCallback && errCallback();
        dispatch(setThankYouLoading(false));
      }
    }).catch(err => {
      errCallback && errCallback();
      dispatch(setThankYouLoading(false));
    });
  };
}
